var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"quotes",attrs:{"title":"Quotes"}},[_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":function($event){return _vm.open(null)}},slot:"tools"}),_c('div',{staticClass:"layout"},[_c('date-picker-std-view',{staticClass:"date",attrs:{"status":_vm._monthStatus},on:{"browse":_vm.updateMonthStatus},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('div',{staticClass:"tasks"}),_c('new-table-view',{staticClass:"list",attrs:{"columns":[
			/*{
				label: 'Status',
				name: ['_embedded', 'status'],
				translation: _status,
				template: {
					name: 'status',
					params: {
						color: {
							name: ['_embedded', 'status'],
							translation: _statusColors
						},
						description: {
							name: ['_embedded', 'status'],
							translation: _statusDesc
						}
					}
				}
			},*/
			/*{
				label: 'Oprettet',
				name: 'created',
				filter: 'timestamp'
			},*/
			{
				label: 'Status',
				name: ['status'],
				translation: _vm._status,
				template: {
					name: 'status',
					params: {
						color: {
							name: ['status'],
							translation: _vm._statusColors
						},
						description: {
							name: ['status'],
							translation: _vm._statusDesc
						}
					}
				}
			},
			{
				label: 'Nr',
				name: 'num',
				filter: 'integer'
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Udløber',
				name: 'valid_to',
				filter: 'days'
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'E-mail',
				name: 'email_sent',
				default: 'Ikke sendt',
				filter: 'days'
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Næste kontakt',
				name: 'next_contact',
				default: 'Kontakt ikke',
				filter: 'days'
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Navn',
				name: ['customer', 'name']
			},
			/*{
				label: 'Kunde',
				name: ['_embedded', 'contact', 'name'],
				//filter: 'float',
				//align: 'right'
			},*/
			{
				label: 'Ansvarlig',
				name: ['_embedded', 'employee', 'name'],
				//filter: 'float',
				//align: 'right'
			},
			{
				label: '',
				name: 'context',
				align: 'right',
				template: {
					name: 'button',
					label: '...'
				}
			}			
		],"items":_vm.items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }